module.exports = __webpack_public_path__ + "static/media/Colizeum_2_t.e49feb5d.jpg";